





















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { debounce } from 'quasar'
import store from 'src/assets/store'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import TopicSettings from 'components/presenter/item/forum/TopicSettings.vue'
import api from 'src/assets/api/gql'
import ForumTopicUpdate from 'src/graphql/forum/ForumTopicUpdate.gql'
import ForumCourseStudentGroups from 'src/graphql/forum/ForumCourseStudentGroups.gql'
import ForumTopicStudentGroupAdd from 'src/graphql/forum/ForumTopicStudentGroupAdd.gql'
import ForumTopicStudentGroupDelete from 'src/graphql/forum/ForumTopicStudentGroupDelete.gql'
import { ForumTopic, ForumTopicPatch, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    TopicSettings
  }
})
export default class ForumTopicButtonSettings extends Vue {
  me = store.state.person
  groups: StudentGroup[] = []
  selected: number[] = []

  @Prop()
  readonly topic!: ForumTopic

  @Ref()
  readonly dialog!: DialogFullscreen

  created () {
    this.selected = (this.topic.forumTopicStudentGroupsByForumTopicIdAndCourseId.nodes || []).map(x => x?.studentGroupId) as number[]
  }

  async edit () {
    this.dialog.show()
    const { data: { forumCourseStudentGroups } } = await api.query({
      query: ForumCourseStudentGroups,
      variables: {
        courseId: this.topic.courseId
      }
    })
    if (forumCourseStudentGroups ) {
      this.groups = forumCourseStudentGroups.nodes as StudentGroup[]
    }
  }

  async toggleGroupSelected (studentGroupId: number) {
    const courseId = this.topic.courseId
    const forumTopicId = this.topic.id
    const selected = this.selected.filter(x => x !== studentGroupId)
    if (selected.length === this.selected.length) {
      await api.mutate({
        query: ForumTopicStudentGroupAdd,
        variables: { courseId, forumTopicId, studentGroupId }
      })
      this.selected.push(studentGroupId)
    } else {
      await api.mutate({
        query: ForumTopicStudentGroupDelete,
        variables: { forumTopicId, studentGroupId }
      })
      this.selected = selected
    }
  }

  async save (patch: ForumTopicPatch) {
    const { data: { updateForumTopic } } = await api.mutate({
      query: ForumTopicUpdate,
      variables: {
        id: this.topic.id,
        patch
      }
    })
    const topic = updateForumTopic?.forumTopic
    if (topic) {
      this.$emit('update', topic)
    }
  }
}
